<template lang="pug">
  div
    .fa.fa-map-marker.fa-2x(@click="pick" style="cursor: pointer; margin-top: 5px;")
    CoordinatesPicker(ref="coordinatesPicker" v-model="coordinates")
</template>

<script>
import CoordinatesPicker from './CoordinatesPicker'

export default {
  props: ['onCoordinatesPicked', 'value'],
  watch: {
    value(v) {
      this.coordinates = { ...v }
    }
  },
  data: () => ({
    coordinates: {}
  }),
  methods: {
    pick() {
      this.$refs.coordinatesPicker.open((p) => {
        this.$emit('onCoordinatesPicked', p)
      })
    }
  },
  components: {
    CoordinatesPicker
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/PickLocationMarker.vue